declare global {
  interface Window {
    cache: typeof Cache;
  }
}

const cache = new Map();

function set(key: string, value: any) {
  localStorage.setItem(`cache:${key}`, JSON.stringify(value));
  cache.set(key, value);
}

function get(key: string, defaultValue: any = null) {
  if (cache.has(key)) {
    return cache.get(key);
  }

  if (localStorage.getItem(`cache:${key}`)) {
    try {
      let value = JSON.parse(localStorage.getItem(`cache:${key}`));
      cache.set(key, value);
      return value;
    } catch (e) {
      localStorage.removeItem(`cache:${key}`);
    }
  }

  return defaultValue;
}

function remove(key: string) {
  localStorage.removeItem(`cache:${key}`);
  cache.delete(key);
}

function has(key: string) {
  return get(key) !== null;
}

export const Cache = {
  set,
  get,
  has,
  remove,
};

window.cache = Cache;
